/** 첫 방문: 골목 → 카운터 → 별채로 건너가기 → 단골 등록 (DEV_SPEC 4.1, 6장) */
import { api } from './client.js';

/** 골목 걷기 전환(시안 05 S0a′) 뒤 카운터로. 동의는 받지 않습니다(D45) */
export function enterWelcome() {
    return api('/welcome/enter', { method: 'POST', body: {} });
}

/** 가입 동의 기록(DEV-07r · D97). consentVersion 은 동의 화면이 받은 판, agreed 는 항목 key → 체크(태어난 해는 받지 않음, 2026-10-16) */
export function consentWelcome({ consentVersion, agreed }) {
    return api('/welcome/consent', { method: 'POST', body: { consentVersion, agreed } });
}

export function fetchCounter({ signal } = {}) {
    return api('/counter', { signal });
}

/**
 * @param {{ chipId?: string, body?: string, birth?: object, post?: string, clientKey: string }} payload
 * 공감 생성이 붙을 수 있어 기본보다 오래 기다립니다(서버 counter 자리 12초 + 위기 분류 8초)
 */
export function sendCounterInput(payload) {
    return api('/counter/messages', { method: 'POST', body: payload, timeoutMs: 30000 });
}

/** 별채에 올릴 말 초안. 아무것도 올리지 않습니다 */
export function draftCounterSummary() {
    return api('/counter/summary', { method: 'POST', timeoutMs: 20000 });
}

export function finishCounter({ notifications }) {
    return api('/counter/finish', { method: 'POST', body: { notifications } });
}
